export default __webpack_public_path__ + "static/media/Remove.a16a2d7b.svg";